/**
=========================================================
* Zaim engineering - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Zaim engineering.
 * You can add new color using this file.
 * You can customized the colors for the entire Zaim engineering using thie file.
 */

const colors = {
  background: {
    default: "#f8fafc",
  },

  text: {
    main: "#64748b",
    focus: "#64748b",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#7c3aed",
    focus: "#6d28d9",
  },

  secondary: {
    main: "#64748b",
    focus: "#94a3b8",
  },

  info: {
    main: "#6366f1",
    focus: "#4f46e5",
  },

  success: {
    main: "#10b981",
    focus: "#0ea371",
  },

  warning: {
    main: "#f59e0b",
    focus: "#d97706",
  },

  error: {
    main: "#ef4444",
    focus: "#dc2626",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#1e293b",
    focus: "#0f172a",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#8b5cf6",
      state: "#7c3aed",
    },

    secondary: {
      main: "#94a3b8",
      state: "#64748b",
    },

    info: {
      main: "#6366f1",
      state: "#4f46e5",
    },

    success: {
      main: "#34d399",
      state: "#10b981",
    },

    warning: {
      main: "#fbbf24",
      state: "#f59e0b",
    },

    error: {
      main: "#f87171",
      state: "#ef4444",
    },

    light: {
      main: "#f1f5f9",
      state: "#e2e8f0",
    },

    dark: {
      main: "#1e293b",
      state: "#0f172a",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#ede9fe",
      text: "#6d28d9",
    },

    secondary: {
      background: "#e2e8f0",
      text: "#475569",
    },

    info: {
      background: "#e0e7ff",
      text: "#4f46e5",
    },

    success: {
      background: "#d1fae5",
      text: "#059669",
    },

    warning: {
      background: "#fef3c7",
      text: "#d97706",
    },

    error: {
      background: "#fee2e2",
      text: "#dc2626",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#7c3aed",
    secondary: "#94a3b8",
    info: "#6366f1",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    light: "#e2e8f0",
    dark: "#1e293b",
  },

  inputBorderColor: "#e2e8f0",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
